<skl-dialog-content-ins [isReady]="viewModel.isFormReady">
	<skl-dialog-header-ins
		[title]="'scenes.configuration.shared.adjustment-reason.dialog.title' | translate"
		id="adjustment-reason-dialog-header"
		(onClose)="onCancel()">
	</skl-dialog-header-ins>

	<ins-content>
		<skl-form-container>
			@if (viewModel.isFormReady) {
				<div class="grid" [sklValidationSource]="viewValidation">
					<div class="col-1">
						<ins-checkbox
							id="adjustment-reason-dialog-default"
							[(ngModel)]="viewModel.bo.model.default"
							[isReadonly]="viewModel.wasDefault"
							[label]="'scenes.configuration.shared.adjustment-reason.dialog.form.default.label' | translate"
							[sklValidate]="getValidationKey('default')">
						</ins-checkbox>
					</div>
					<div class="col-1">
						<ins-form-field
							[label]="'scenes.configuration.shared.adjustment-reason.dialog.form.name.label' | translate">
							<ins-input
								id="adjustment-reason-dialog-name"
								[skl-focus-by]
								[(ngModel)]="viewModel.bo.model.name"
								[placeholder]="'scenes.configuration.shared.adjustment-reason.dialog.form.name.placeholder' | translate"
								[sklValidate]="getValidationKey('name')">
							</ins-input>
						</ins-form-field>
					</div>
				</div>
			}
		</skl-form-container>

	</ins-content>

	<ins-footer class="dialog__buttons">
		<skl-button
			id="adjustment-reason-dialog-cancel-button"
			(click)="onCancel()">
			{{ 'scenes.configuration.shared.base.dialog.buttons.cancel' | translate }}
		</skl-button>
		<skl-button
			id="adjustment-reason-dialog-save-button"
			typeName="accent"
			[spinner]="viewModel.isSaving"
			(click)="onConfirmAsync()">
			{{ 'scenes.configuration.shared.base.dialog.buttons.save' | translate }}
		</skl-button>
	</ins-footer>
</skl-dialog-content-ins>